import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { projectSelector } from "views/ProjectPage/RightPart/AllTaskTable/selectors";
import DeleteProjectModal from "views/ProjectGroupPage/Modals/DeleteProject";
import Member from "./Member";
import Appointment from "./Appointment";
import ImageVideo from "./ImageVideo";
import FileBox from "./FileBox";
import LinkBox from "./LinkBox";
import "./styles.scss";

function TabBody(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { project } = useSelector(projectSelector);
  const [isOpenDeleteModal, setOpenDeleteModal] = useState(false);

  const handleShowDeleteModal = () =>
    setOpenDeleteModal((preState) => !preState);

  const handleSetDefaultMediaTab = (tab) => {
    localStorage.setItem("JobDetail/DefaultMediaTab", tab);
  };

  return (
    <div className="listPartTabBody">
      <Member />
      <Appointment setShow={props.setShow} />
      <ImageVideo
        setShow={props.setShow}
        setDefaultMediaTab={handleSetDefaultMediaTab}
      />
      <FileBox
        setShow={props.setShow}
        setDefaultMediaTab={handleSetDefaultMediaTab}
      />
      <LinkBox
        setShow={props.setShow}
        setDefaultMediaTab={handleSetDefaultMediaTab}
      />
      {project?.can_delete && (
        <>
          <div
            className="listPartTabBody--remove_task listPartTabBody--menuItem-btn"
            onClick={handleShowDeleteModal}
          >
            <DeleteOutlinedIcon /> {t("LABEL_CHAT_TASK_XOA_BANG_VIEC")}
          </div>
          {isOpenDeleteModal && (
            <DeleteProjectModal
              open={isOpenDeleteModal}
              setOpen={handleShowDeleteModal}
              projectGroupId={project?.group_project_id}
              selectedProject={project}
              doAfterSuccess={() => history.replace(`/projects`)}
            />
          )}
        </>
      )}
    </div>
  );
}

export default TabBody;
